"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _index = require("./templates/index.js");

var _index2 = require("./pipelines/index.js");

var _index3 = require("./helpers/index.js");

var _index4 = require("./utils/index.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var alloyAnalytics = {
  _settings: {},
  _eventTypes: new Set(),
  _webPageDetails: undefined,
  _webInteraction: undefined,
  _productListItems: undefined,
  _commerce: undefined,
  _search: undefined,
  config: function config(_ref) {
    var defaultValues = _ref.defaultValues;
    this._settings.defaultValues = defaultValues;
  },
  event: function event(type) {
    this._eventTypes.add(type);

    this.webPageDetails();
    this.webInteraction(type);
    this.commerce(type);
    return alloyAnalytics;
  },
  webPageDetails: function webPageDetails(data) {
    var _this$_settings$defau;

    var eventType = _toConsumableArray(this._eventTypes)[0];

    var defaultValues = (_this$_settings$defau = this._settings.defaultValues) === null || _this$_settings$defau === void 0 ? void 0 : _this$_settings$defau.webPageDetails;
    var values = data ? _objectSpread(_objectSpread({}, defaultValues), data) : defaultValues;
    var template = (0, _index.getWebPageDetailsTemplate)(eventType, values);
    this._webPageDetails = template;
    return alloyAnalytics;
  },
  webInteraction: function webInteraction(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';

    var _ref2 = isEventType ? {
      eventType: eventTypeOrData,
      values: data
    } : {
      eventType: _toConsumableArray(this._eventTypes)[0],
      values: eventTypeOrData
    },
        eventType = _ref2.eventType,
        values = _ref2.values;

    this._eventTypes.add(eventType);

    var template = (0, _index.getWebInteractionTemplate)(eventType, values);
    this._webInteraction = (0, _index4.mergeObjects)(template, this._webInteraction);
    return alloyAnalytics;
  },
  productListItems: function productListItems(productOrProducts) {
    var isArray = Array.isArray(productOrProducts);
    var products = this._productListItems || [];
    if (isArray) products = products.concat(productOrProducts.map(_index.getProductTemplate));else products.push((0, _index.getProductTemplate)(productOrProducts));
    this._productListItems = products;
    return alloyAnalytics;
  },
  commerce: function commerce(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';

    var _ref3 = isEventType ? {
      eventType: eventTypeOrData,
      values: data
    } : {
      eventType: _toConsumableArray(this._eventTypes)[0],
      values: eventTypeOrData
    },
        eventType = _ref3.eventType,
        values = _ref3.values;

    this._eventTypes.add(eventType);

    var template = (0, _index.getCommerceTemplate)(eventType, values);
    this._commerce = template;
    return alloyAnalytics;
  },
  search: function search(eventTypeOrData, data) {
    var isEventType = typeof eventTypeOrData === 'string';

    var _ref4 = isEventType ? {
      eventType: eventTypeOrData,
      values: data
    } : {
      eventType: _toConsumableArray(this._eventTypes)[0],
      values: eventTypeOrData
    },
        eventType = _ref4.eventType,
        values = _ref4.values;

    this._eventTypes.add(eventType);

    var template = (0, _index.getSearchTemplate)(eventType, values);
    this._search = template;
    return alloyAnalytics;
  },
  fire: function fire() {
    var event = (0, _index3.getEvent)(this);
    var processedEvent = (0, _index2.executePipeline)(this._eventTypes, event);
    (0, _index3.pushEventToDataLayer)(processedEvent);
    this.reset();
  },
  preview: function preview() {
    var event = (0, _index3.getEvent)(this);
    var processedEvent = (0, _index2.executePipeline)(this._eventTypes, event);
    var cleanedEvent = (0, _index4.removeEmptyKeys)(processedEvent);
    return cleanedEvent;
  },
  reset: function reset() {
    this._eventTypes.clear();

    delete this._webPageDetails;
    delete this._webInteraction;
    delete this._productListItems;
    delete this._commerce;
    delete this._search;
  }
};
var _default = alloyAnalytics;
exports["default"] = _default;